import { type BrandingUpdate } from '@domain/schemas/branding.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import axios from 'axios';

// The branding PATCH handlers return no body (empty 200), so there is no response type to share yet
export const updateBranding = async (data: BrandingUpdate, id: string): Promise<void> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: '/brandings/' + id,
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
